import { useState, useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import CreateCardPayment from "./CreateCardPayment";
import GetCardPayments from "./GetCardPayments";
import View from "../../../../utils/View";
import ExpressChargeMainPage from "./ExpressChargeMainPage";
import { PAYMENT } from "../../../../../constants/api";

const screens = ["introductionScreen", "tableScreen", "formScreen"];

const makeRequest = async (type = "ECOMMERCE") => {
  const query = {
    type,
  };
  try {
    const response = await axios.get(PAYMENT, {
      params: query,
    });
    return response;
  } catch (error) {
    return error;
  }
};

const ExpressCharge = () => {
  const [cardPayments, setCardPayments] = useState([]);

  const [loading, setLoading] = useState(true);

  const [currentScreen, setCurrentScreen] = useState(screens[0]);

  const getData = async () => {
    const response = await makeRequest();

    if (response?.data?.success) {
      const data = response.data?.result?.operations?.map((cardPayment) => {
        const diffdays = dayjs().diff(dayjs(cardPayment.timestamp), "days");
        const status =
          cardPayment.status === 1 && diffdays > 4 ? 0 : cardPayment.status;
        const id = uuidv4();
        const payments = cardPayment.payments || [];

        return {
          id, // unique identifier for each row of data
          status,
          product: cardPayment.reference?.description,
          amount: cardPayment.total?.amount,
          url:
            status === 1 ? cardPayment.url : payments[payments.length - 1]?.url,
        };
      });

      setCardPayments(data);

      if (data.length > 0) {
        setCurrentScreen(screens[1]);
      }

      setLoading(false);
    } else {
      // TODO: get back to handle error
      console.error("Backend error", response);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const screensObj = {
    [screens[0]]: (
      <ExpressChargeMainPage
        isLoading={loading}
        onButtonClick={() => setCurrentScreen(screens[2])}
      />
    ),
    [screens[1]]: (
      <GetCardPayments
        isLoading={loading}
        onApply={() => setCurrentScreen(screens[2])}
        loading={loading}
        cardPayments={cardPayments}
      />
    ),
    [screens[2]]: (
      <CreateCardPayment
        isLoading={loading}
        onReturn={() => {
          cardPayments.length
            ? setCurrentScreen(screens[1])
            : setCurrentScreen(screens[0]);
        }}
        onSubmit={async () => {
          await getData();
          setCurrentScreen(screens[1]);
        }}
      />
    ),
  };

  return (
    <View translateTitleKey="menu.cobroExpress">
      {screensObj[currentScreen]}
    </View>
  );
};

export default ExpressCharge;
